import type { ReactNode } from "react";
import type { MilestoneItem } from "@wayflyer/flyui";

export type OnboardingStep = {
  id: string;
  label: string;
  description?: string | ReactNode;
  subtext?: string;
  onClick?: () => void;
  analyticsId?: string;
  substeps?: Array<{
    id: string;
    label: string;
    onClick?: () => void;
    analyticsId?: string;
  }>;
};

export function buildMilestones(
  steps: OnboardingStep[],
  completedStepIds?: string[],
  completedSubstepIds?: string[]
): MilestoneItem[] {
  const completedSteps = new Set(completedStepIds ?? []);
  const completedSubsteps = new Set(completedSubstepIds ?? []);

  return steps.map((step): MilestoneItem => {
    const baseProps = {
      id: step.id,
      label: step.label,
      isExpandable: true,
      slots: {
        description: step.description,
        subtext: step.subtext,
      },
    };

    if (step.substeps) {
      const mappedSubsteps = step.substeps.map((sub) => ({
        id: sub.id,
        label: sub.label,
        isCompleted: completedSubsteps.has(sub.id),
        ...addClickableProps(sub.onClick, sub.analyticsId),
      }));

      return {
        ...baseProps,
        isCompleted: mappedSubsteps.every((sub) => sub.isCompleted),
        substeps: mappedSubsteps,
      };
    }

    return {
      ...baseProps,
      isCompleted: completedSteps.has(step.id),
      ...addClickableProps(step.onClick, step.analyticsId),
    };
  });
}

function addClickableProps(onClick?: () => void, analyticsId?: string) {
  return onClick ? { onClick, analyticsId } : {};
}
